import DropdownHandler from './PillDropdown'

export default DropdownHandler
